import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import s from './style.css';
import CircleProgress from '../CircleProgress';
import { app } from '../../actions';
const ImageFile = (props) => {
    const VideoView = ({ file, uri }) => {
        const width = file.width > file.height ? window.outerWidth * 0.5 : (file.width * window.innerHeight) / file.height;
        const height = file.width > file.height ? (file.height * (window.outerWidth * 0.5)) / file.width : window.innerHeight;
        return (React.createElement("video", { onError: handleError, controls: true, autoPlay: true, width: width, height: height },
            React.createElement("source", { src: uri, type: 'video/mp4' }),
            React.createElement("track", { kind: 'captions' })));
    };
    const [retried, setRetried] = useState(false);
    useEffect(() => {
        if (!props.uri ||
            (!props.file.isPhoto && !props.fileTempLoaded) ||
            (props.file.type.includes('heic') && !props.heicUri)) {
            props.cacheVaultFile({ file: props.file });
        }
    }, []);
    useEffect(() => {
        setRetried(false);
        if (!props.uri || (!props.file.isPhoto && !props.fileTempLoaded)) {
            props.cacheVaultFile({ file: props.file });
        }
    }, [props.currentIndex]);
    const handleError = () => {
        if (retried)
            return;
        setRetried(true);
        props.cacheVaultFile({ file: props.file });
    };
    const { file } = props;
    return (React.createElement("div", { className: s.container },
        !file.isPhoto && props.uri && props.fileTempLoaded ? (React.createElement("iframe", { onError: handleError, src: props.uri, style: { background: '#ffffff' }, width: '1200', height: window.innerHeight, title: `iframe-${file.uriKey}` })) : file.type.startsWith('video') && props.uri && !props.downloadProgress ? (React.createElement(VideoView, { file: file, uri: props.uri })) : file.type.startsWith('image') ? (React.createElement("img", { src: props.uri && !props.downloadProgress
                ? props.file.type.toLowerCase().includes('heic')
                    ? props.heicUri
                    : props.uri
                : props.previewUri, className: s.imageFile, onError: handleError, onContextMenu: props.handleContextMenu })) : null,
        props.downloadProgress ? (React.createElement("div", { className: s.progressContainer }, props.heicProcessing ? (React.createElement("p", { className: s.processing }, "PROCESSING...")) : (React.createElement(CircleProgress, { progress: props.downloadProgress, size: 80, strokeWidth: 3, opacity: 0.7 })))) : null));
};
const mapStateToProps = (state, ownProps) => ({
    uri: state.vaultCache[ownProps.file.uriKey] ? state.vaultCache[ownProps.file.uriKey].uri : null,
    heicUri: state.vaultCache[`${ownProps.file.uriKey}-heic`]
        ? state.vaultCache[`${ownProps.file.uriKey}-heic`].uri
        : null,
    previewUri: state.vaultCache[ownProps.file.previewUriKey]
        ? state.vaultCache[ownProps.file.previewUriKey].uri
        : null,
    downloadProgress: state.download[ownProps.file.uriKey] ? state.download[ownProps.file.uriKey] : null,
    heicProcessing: state.heic[ownProps.file.uriKey],
    fileTempLoaded: state.appTemp.fileTempLoaded[ownProps.file.uriKey],
    currentIndex: state.appTemp.fileView.index,
});
const connector = connect(mapStateToProps, { ...app });
export default connector(ImageFile);
